"use client";

import { Suspense } from "react";
import { LoginForm } from "@/components/login-form";
import { BrandingPanel } from "@/components/branding-panel";
import { LoadingScreen } from "@/components/loading-screen";

export default function LoginPage() {
  return (
    <div className="flex min-h-screen flex-row-reverse">
      {/* Login Form - left in Arabic (RTL), right in English (LTR) */}
      <div className="flex-1 lg:w-1/2 bg-pattern">
        <Suspense fallback={<LoadingScreen />}>
          <LoginForm />
        </Suspense>
      </div>

      {/* Branding Panel - right in Arabic (RTL), left in English (LTR) */}
      <div className="hidden lg:block lg:w-1/2">
        <BrandingPanel />
      </div>
    </div>
  );
}
